import React from "react";

export default function JS_Static_Methods() {
  return (
    <div className="tutorial-container">
      <h1>JS Static Methods</h1>
      <p>
        This tutorial explains the concept of JS Static Methods in JavaScript
        OOPs.
      </p>
    </div>
  );
}
